<template>
    <div style="background-color: #fafafa;">
        <van-tabs v-model="selected" type="card" color="#1890ff" sticky swipeable @click="switchTab">
            <van-tab title="经销商排名">
                <div class="rankSearchBox">
                    <van-search class="search-box" shape="round" v-model="value" placeholder="以经销商名字搜索" show-action @search="onSearch(0)" @input="onSearch(0)"
                                @cancel="onSearch(0)" @clear="onSearch(0)">
                        <div style="padding-top: 10px;" slot="action" @click="showFilterPop()"><van-icon name="filter-o" size="20"/></div>
                    </van-search>
                </div>
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh(0)">
                    <van-list v-model="loading" :finished="finished" @load="getRadDealerRankList(0)" class="listBox"  finished-text="没有更多了">
                        <div v-for="item in list" class="card" :key="item.uuid" @click="openOrderDetail(item)">
                            <table class="layout">
                                <tr style="width: 100%;">
                                    <td style="text-align: center;width: 15%;">
                                        <div>
                                             <span class="numberSpanBack">
                                               <span class="numberSpan">{{item.rankIndex}}</span>
                                            </span>
                                        </div>
                                    </td>
                                    <td style="text-align: left;width: 50%;">
                                        <p>
                                            <span>{{item.dealerIdname}}</span>
                                        </p>
                                    </td>
                                    <td style="text-align: left;width: 35%;">
                                        <p>
                                            <span>销售额:¥</span>
                                            <span style="color: #1890ff">{{item.amount}}</span>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
            <van-tab title="导购排名">
                <div class="rankSearchBox">
                    <van-search class="search-box" shape="round" v-model="value" placeholder="以导购名字搜索" show-action @search="onSearch(1)" @input="onSearch(1)"
                                @cancel="onSearch(1)" @clear="onSearch(1)">
                        <div style="padding-top: 10px;" slot="action" @click="showFilterPop()"><van-icon name="filter-o" size="20"/></div>
                    </van-search>
                </div>
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh(1)">
                    <van-list v-model="loading" :finished="finished" @load="getRadDealerRankList(1)" class="listBox" finished-text="没有更多了">
                        <div v-for="item in list" class="card" :key="item.uuid" @click="openOrderDetail(item)">
                            <table class="layout">
                                <tr style="width: 100%;">
                                    <td style="text-align: center;width: 15%;">
                                        <div>
                                            <span class="numberSpanBack">
                                               <span class="numberSpan">{{item.rankIndex}}</span>
                                            </span>
                                        </div>
                                    </td>
                                    <td style="text-align: left;width: 50%;">
                                        <p>
                                            <span>{{item.dealerIdname}}--{{item.creatorIdname}}</span>
                                        </p>
                                    </td>
                                    <td style="text-align: left;width: 35%;">
                                        <p>
                                            <span>销售额:¥</span>
                                            <span style="color: #1890ff">{{item.amount}}</span>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
        </van-tabs>
        <van-popup v-model="showFilter" closeable position="bottom" :style="{ height: '80%' }"
                   :close-on-click-overlay="false">
            <van-nav-bar title="过滤条件" left-text="取消" right-text="确定"
                         @click-left="onFilterClickLeft()" @click-right="onFilterClickRight()" />
            <table class="layout">
                <tr>
                    <td>
                        <van-field-date v-model="startTime" type="date" format="yyyy-MM-dd" label="开始时间"></van-field-date>
                        <van-field-date v-model="endTime" format="yyyy-MM-dd" type="date" label="结束时间"></van-field-date>
                        <van-field-acb v-model="status" dict="dict_rank_order_status" label="订单状态"></van-field-acb>
                    </td>
                </tr>
            </table>
        </van-popup>
        <div class="recordBox">
            <table style="background-color: #1989fa;width: 100%;margin-bottom: 3px;">
                <tr style="height:40px;">
                    <td style="width: 50%;color:white;text-align: right;">总金额:</td>
                    <td style="width: 50%;color:white;text-align: left;">{{ amount }}</td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
    import {Tab, Tabs, Panel, Field, List, Search, Popup, PullRefresh, NavBar, Icon, Button} from 'vant';
    import dealerOrderService from "../../service/dealerOrderService";
    import {formatDictionary} from "../../utils/dictionary";
    import VanFieldAcb from '../../components/VanFieldAcb';
    import VanFieldDate from "../../components/VantFieldDate";
    import moment from "moment";

    export default {
        data: function () {
            return {
                selected: 0,
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                value: '',
                refreshing: false,
                type: "1",
                amount: "",
                status: "1",
                showFilter: false,
                startTime: new Date().getFullYear() + "-01-01",
                endTime: moment(new Date()).format('YYYY-MM-DD')
            }
        },
        components: {
            VanFieldAcb,
            VanFieldDate,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Panel.name]: Panel,
            [Field.name]: Field,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [NavBar.name]: NavBar,
            [Button.name]: Button,
            [Icon.name]: Icon,
            [PullRefresh.name]: PullRefresh
        },
        methods: {
            async getRadDealerRankList(index) {
                switch (index) {
                    case 0:
                        this.type = "1";
                        break;
                    case 1:
                        this.type = "2";
                        break;
                    default: break;
                }
                this.pageIndex++;
                let resp = await dealerOrderService.getRadDealerRankList(this.pageIndex, this.value, this.type, this.startTime, this.endTime, this.status);
                if (resp.data.Status === "1"){
                    formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                    this.loading = false;
                    this.refreshing = false;
                    this.list = [...this.list, ...resp.data.Data.data];
                    this.finished = resp.data.Data.total <= this.list.length;
                    if(this.pageIndex === 1){
                        this.amount = parseFloat(resp.data.Data.expressions.amount || "0.00").toFixed(2);
                    }
                }
            },
            onRefresh(index){
                this.list = [];
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.getRadDealerRankList(index);
            },
            onSearch(index){
                this.onRefresh(index);
            },
            switchTab(index) {
                window.scrollTo(0, 0);
                this.value = "";
                this.showFilter = false;
                this.onRefresh(index)
            },
            showFilterPop(){
                this.showFilter = true;
            },
            onFilterClickLeft(){
                this.showFilter = false;
            },
            onFilterClickRight(){
                this.showFilter = false;
                if(this.type === "1"){
                    this.onSearch(0);
                }else{
                    this.onSearch(1);
                }
            },
            openOrderDetail(item){
                this.$router.push({path: "/rad/dealerRank/order",
                                    query: { dealerId: item.dealerId,
                                             creatorId: this.type === "2" ? item.creatorId : "",
                                             startTime: this.startTime,
                                             endTime: this.endTime,
                                             status: this.status
                }});
            }
        }
    };
</script>

<style>
    .search-box {
        margin-top: 0;
    }
    .listBox{
        width: 100%;
        margin-top: 0;
    }
    .card p {
        margin:10px 0;
    }
    .card p>span:first-child {
        flex: 0 0 4rem;
        text-align: right;
        margin-right: 20px;
    }
    .van-pull-refresh__head{
        display: none;
    }
    .recordBox {
        padding: 0.5rem 0;
        box-sizing: border-box;
        margin-top: 2rem;
        bottom:-10px;
        position:fixed;
        width: 100%;
    }
    .numberSpanBack{
        border-radius: 50%;
        height: 70px;
        width: 70px;
        display: inline-block;
        background: #238ff9;
        vertical-align: top;
    }
    .numberSpan{
        display: block;
        color: #FFFFFF;
        height: 70px;
        line-height: 70px;
        text-align: center
    }
    .rankSearchBox {
        height: 3rem;
        box-sizing: border-box;
        margin-bottom: 2rem;
        top: 1.9rem;
        position:fixed;
        width: 100%;
        z-index:999;
    }
</style>